export default __webpack_public_path__ + "static/media/ASSETS-create-asset.5662d24f.png";